export const SEARCH_REQUEST = 'search/SEARCH_REQUEST';
export const SEARCH_SUCCESS = 'search/SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'search/SEARCH_FAILURE';
export const SEARCH_CLEAR = 'search/SEARCH_CLEAR';
export const SET_SEARCH_QUERY = 'search/SET_SEARCH_QUERY';

export const setSearchQuery = value => ({
  type: SET_SEARCH_QUERY,
  payload: value
});

export const searchRequest = query => ({
  type: SEARCH_REQUEST,
  payload: {
    query
  }
});

export const searchSuccess = results => ({
  type: SEARCH_SUCCESS,
  payload: {
    results
  }
});

export const searchFailure = () => ({ type: SEARCH_FAILURE });
export const searchClear = () => ({ type: SEARCH_CLEAR });
